/**
 * Die Wörter für Dank und Abschied — EIN Besitzer für Server und Seite. (16.10.2026)
 *
 * Bis hierher standen sie nur in server/reflex-antwort.ts (die enge Weiche „ist die GANZE Äußerung ein Dank/Abschied?“). Seit dem
 * Abschied an den Schmied (shared/schmied.ts, `abschiedAnSchmied` / `verabschiedetSchmied`) braucht dieselbe Liste auch eine
 * zweite Stelle — darum steht sie hier, und die Reflex-Antwort liest sie von hier.
 *
 * Die Bausteine gelten auf dem BEREINIGTEN Text (`bereinigt`: klein, nur Buchstaben und Ziffern, ein Leerzeichen zwischen den
 * Wörtern) — „Mach's gut!“ wird zu „mach s gut“.
 */

/** Klein, nur Buchstaben und Ziffern (auch ä ö ü ß), ein Leerzeichen zwischen den Wörtern. Rein. */
export function bereinigt(text: string): string {
  return String(text ?? "")
    .normalize("NFC")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

/** Füllwörter vor einem Dank oder Abschied („okay, danke“). */
export const FUELLER = "(?:okay|ok|gut|super|perfekt|prima|toll|klasse|alles klar)";

/** Ein Dank („danke“, „vielen Dank dafür“). */
export const DANK =
  "(?:danke(?:schön|schoen|sehr)?|dank dir|(?:vielen|herzlichen|besten|tausend|vielen lieben) dank)" +
  "(?: (?:dir|sehr|schön|schoen|vielmals|dafür|dafuer)){0,2}";

/** Ein Abschied („tschüss“, „bis später“, „mach's gut“). */
export const ABSCHIED =
  "(?:tschüss|tschüß|tschuess|tschuss|tschö|baba|auf wiedersehen|wiedersehen" +
  "|bis (?:später|spaeter|dann|bald|gleich|nachher|morgen|zum nächsten mal)|mach s gut|schönen (?:tag|abend) noch)";
